module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasNav || _vm.currentIcons.length > 0 || _vm.hasComponentsAroundIcons) ? _c('header', {
    staticClass: "header is-desktop is-fixed"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('header-nav', {
    attrs: {
      "current-nav": _vm.currentNav,
      "has-nav": _vm.hasNav,
      "show-nav": _vm.showNav
    }
  }), _vm._v(" "), (_vm.currentIcons.length > 0 || _vm.hasComponentsAroundIcons) ? _c('div', {
    staticClass: "header-right"
  }, [_c('custom-components', {
    attrs: {
      "place": "icons:start"
    }
  }), _vm._v(" "), _c('header-icons', {
    attrs: {
      "current-icons": _vm.currentIcons,
      "show-nav": _vm.showNav
    }
  }), _vm._v(" "), _c('custom-components', {
    attrs: {
      "place": "icons:end"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c1b43e72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeHeader.vue
// module id = 105
// module chunks = 0